import React from 'react';
import useStyles from './styles';
import { Typography } from '@material-ui/core';
import PhoneImage from '@assets/courier-getstarted-phone-2x.png';
import JetFontIcon, {
  JET_FONTICON_ALIASES,
} from '@src/shared/components/JetFontIcon';
import AppStoreBadgeImage from '@assets/appstore-badge.png';
import GooglePlayBadgeImage from '@assets/google-play-badge.png'
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import JetButton from '@src/shared/components/JetButton';
import { Trans, useTranslation } from 'react-i18next';
const CourierGetStartedContent = (props: any) => {
  const classes = useStyles();
  const { isResolutionMobile } = useDeviceDetect()
  const { t } = useTranslation()
  return (
    <div className={classes.courierGetStartedContent}>
      <Typography
        variant={isResolutionMobile ? "h3" : "h1"} 
        className={`${isResolutionMobile ? "heading_l" : "heading_xxl"} couriergetstartedcontent-title`}
        align="center"
      >
        <JetFontIcon
          className="title-icon"
          iconname={JET_FONTICON_ALIASES.DRIVER_MOPED}
          size={isResolutionMobile ? 24 : 33} 
        />{' '}
        {t('new_productoverview_courier.section7_title')}
      </Typography>
      <div className="couriergetstarted-content-container">
        <div className="couriergetstarted-content-side-section-1">
          <ul className="couriergetstarted-content-side-section-1-articles">
            <li>
              {' '}
              <Typography variant="body1" className="body_regular" align="left">
                <JetFontIcon
                  className="article-icon"
                  iconname={JET_FONTICON_ALIASES.CHECK_CIRCLE_FILLED}
                  size={24}
                />{' '}
                <Trans i18nKey="new_productoverview_courier.section7_article1" components={{ strong: <strong /> }} />
              </Typography>
            </li>
            <li>
              <Typography variant="body1" className="body_regular" align="left">
                <JetFontIcon
                  className="article-icon"
                  iconname={JET_FONTICON_ALIASES.CHECK_CIRCLE_FILLED}
                  size={24}
                />{' '}
                {t('new_productoverview_courier.section7_article2')}
              </Typography>
            </li>
            <li>
              <Typography variant="body1" className="body_regular" align="left">
                <JetFontIcon
                  className="article-icon"
                  iconname={JET_FONTICON_ALIASES.CHECK_CIRCLE_FILLED}
                  size={24}
                />{' '}
                <Trans i18nKey="new_productoverview_courier.section7_article3" components={{ strong: <strong /> }} />
              </Typography>
            </li>
          </ul>
         {!isResolutionMobile && <div className="couriergetstarted-store-links">
            <img onClick={props.onIosDownload} src={AppStoreBadgeImage} />
            <img onClick={props.onAndroidDownload} src={GooglePlayBadgeImage} />
          </div> ||  <JetButton onClick={props.onAutoDetectDownload} size="large" variation="primary" className={'get_started_button'}>
            {t('new_productoverview_courier.common_download_now_button')}
          </JetButton>}
        </div>
        <div className="couriergetstarted-content-side-section-2">
          <img src={PhoneImage} />
        </div>
      </div>
    </div>
  );
};

export default CourierGetStartedContent;
